import React, { createContext, useCallback, useContext, useState } from 'react';

interface FinancialFormActionsContextType {
  triggerSave: () => void;
  setSaveHandler: (handler: (() => void) | null) => void;
  saving: boolean;
  setSaving: (value: boolean) => void;
}

const FinancialFormActionsContext = createContext<
  FinancialFormActionsContextType | undefined
>(undefined);

export const useFinancialFormActions = () => {
  const context = useContext(FinancialFormActionsContext);
  if (!context) {
    throw new Error(
      'useFinancialFormActions must be used within FinancialFormActionsProvider',
    );
  }
  return context;
};

export const FinancialFormActionsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [saveHandler, setSaveHandlerState] = useState<(() => void) | null>(null);
  const [saving, setSaving] = useState(false);

  const setSaveHandler = useCallback((handler: (() => void) | null) => {
    setSaveHandlerState(() => handler);
  }, []);

  const triggerSave = useCallback(() => {
    if (saveHandler) {
      saveHandler();
    }
  }, [saveHandler]);

  return (
    <FinancialFormActionsContext.Provider
      value={{ triggerSave, setSaveHandler, saving, setSaving }}
    >
      {children}
    </FinancialFormActionsContext.Provider>
  );
};
